var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangepassword({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66669 13.333C1.66669 10.9763 1.66669 9.79717 2.39919 9.06551C3.13085 8.33301 4.31002 8.33301 6.66669 8.33301H13.3334C15.69 8.33301 16.8692 8.33301 17.6009 9.06551C18.3334 9.79717 18.3334 10.9763 18.3334 13.333C18.3334 15.6897 18.3334 16.8688 17.6009 17.6005C16.8692 18.333 15.69 18.333 13.3334 18.333H6.66669C4.31002 18.333 3.13085 18.333 2.39919 17.6005C1.66669 16.8688 1.66669 15.6897 1.66669 13.333Z",
    stroke: "#2B2B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.33317V6.6665C5 5.34042 5.52678 4.06865 6.46447 3.13097C7.40215 2.19329 8.67392 1.6665 10 1.6665C11.3261 1.6665 12.5979 2.19329 13.5355 3.13097C14.4732 4.06865 15 5.34042 15 6.6665V8.33317",
    stroke: "#2B2B2B",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 13.333H6.67419M9.99252 13.333H10M13.3259 13.333H13.3334",
    stroke: "#2B2B2B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangepassword);
export default __webpack_public_path__ + "static/media/changepassword.6f773963faf0a0dd1f6fcf0f14d18e57.svg";
export { ForwardRef as ReactComponent };